export default __webpack_public_path__ + "static/media/photo--lg--144.d343979b.jpg";